import "react";
import { jsx as o, jsxs as e } from "react/jsx-runtime";
var t = (r) => /* @__PURE__ */ e("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...r,
  children: [/* @__PURE__ */ o("path", {
    d: "M4 4L20 20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ o("path", {
    d: "M20 4L4 20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
});
export {
  t as default
};

//# sourceMappingURL=Close.js.map